import type { InventoryMapObjectData, InventoryMapObjectTypes } from '@/widgets'
import InventObjectLine from './InventObjectLine.ts'
import InventObjectPolygon from './InventObjectPolygon.ts'
import InventObjectPoint from './InventObjectPoint.ts'

export class InventObjectCreator {
  static create(objectData: InventoryMapObjectData, objectType: InventoryMapObjectTypes) {
    switch (objectType.figure.geom_type) {
      case 'LineString':
        return new InventObjectLine(objectData, objectType)
      case 'Polygon':
        return new InventObjectPolygon(objectData, objectType)
      default:
        return new InventObjectPoint(objectData, objectType)
    }
  }
}
